module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.5591/js/img/middle-blob.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/middle-blob.svg
// module id = 799
// module chunks = 5 6